import { MutableRefObject, useEffect, useState } from 'react';

import { ECountry } from '@core/type';

const PLACE_CHANGED = 'place_changed';

export const useGooglePlace = (
  inputRef: MutableRefObject<HTMLInputElement>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  autoCompleteRef: MutableRefObject<any>,
  countryCode: ECountry,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handlePlaceChanged: (place: any) => void,
) => {
  const [isGoogleLoaded, setGoogleLoaded] = useState(false);

  useEffect(() => {
    const handleGoogleLoaded = () => {
      setGoogleLoaded(true);
    };

    window.addEventListener('googlePlaceLoaded', handleGoogleLoaded);

    return () => window.removeEventListener('googlePlaceLoaded', handleGoogleLoaded);
  }, []);

  useEffect(() => {
    if (!window.google) {
      return;
    }
    const options = countryCode
      ? {
          componentRestrictions: { country: countryCode },
        }
      : {};

    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    autoCompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, options);

    if (autoCompleteRef.current) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      autoCompleteRef.current.addListener(PLACE_CHANGED, async function () {
        if (autoCompleteRef.current) {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
          const place = await autoCompleteRef.current.getPlace();
          handlePlaceChanged(place);
        }
      });
    }
  }, [countryCode, autoCompleteRef, inputRef, handlePlaceChanged, isGoogleLoaded]);
};
